// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b1-0";
export var orangeButton = "_b1-1";